module.exports = __webpack_public_path__ + "img/icon3.f06b9608.png";